import { useContext } from "react"
import { AuthContext } from "../providers/auth-provider"

const GetUser = () => {
    const { user } = useContext(AuthContext)

    return user
}

export default GetUser